import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PressReleaseComponent } from './press-release.component';
import { PressReleaseDetailsComponent } from './press-release-details/press-release-details.component';

const routes: Routes = [
  {
    path: '',
    component: PressReleaseComponent,
    data: {
      role: 'PRESS_RELEASE',
    },
    title: 'Press-Release',
  },
  {
    path: ':id',
    component: PressReleaseDetailsComponent,
    data: {
      role: 'PRESS_RELEASE_DETAILS',
    },
    title: 'Press-Release-Details',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PressReleaseRoutingModule { }
